export const getPortalDataSources = (API, request, callback) => {
    API.get(`datasources`).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}

export const getPortalAminoAcidDataSources = (API, request, callback) => {
    API.get(`datasources/aminoAcidDataSource`).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}

